<script>
import { mapGetters } from 'vuex';
import { BOverlay } from 'bootstrap-vue';
import SLSCondicaoPagamentoService from '@/services/SistemaDKP/SLSCondicaoPagamento.service';
import ToastificationContent from '@/@core/components/toastification/ToastificationContent.vue';
import SLSPicService from '@/services/Operacoes/SLSPic.service';

const slsCondicaoPagamentoService = new SLSCondicaoPagamentoService();
const picService = new SLSPicService();
export default {
  name: 'ModalBuscarTabelaPreco',
  components: { BOverlay },
  data() {
    return {
      isLoading: false,
      filtersHeader: {
        condicaopagamentoid: '',
        condicaopagamentodescricao: '',
      },
      currentPage: 1,
      fields: [
        { key: 'condicaopagamentoid', label: 'Código' },
        { key: 'condicaopagamentodescricao', label: 'Descrição' },
        { key: 'acoes', label: 'Ações' },
      ],
      dataFetchedForCliente: {},
    };
  },
  watch: {
    currentPage: {
      handler(value) {
        this.$store.commit('SLSCondicaoPagamento/SET_FILTERS', {
          ...this.$store.getters['SLSCondicaoPagamento/GET_FILTERS'],
          page: value,
        });
      },
    },
  },
  computed: {
    ...mapGetters('SLSCondicaoPagamento', {
      filters: 'GET_FILTERS',
      currentCondPagameto: 'GET_COND_PAGTOS',
    }),
    dataMetaRepresentante() {
      const localCount = this.currentCondPagameto.length;
      const meta = {
        page: this.filters.perPage * (this.filters.page - 1) + (localCount ? 1 : 0),
        perPage: this.filters.perPage * (this.filters.page - 1) + localCount,
        total: this.filters.total,
      };
      return `Mostrando ${meta.page} de ${meta.perPage} entradas de ${meta.total} entradas`;
    },
  },
  methods: {
    async getCondicaoPagamentoByClienteId() {
      const clienteId = this.$store.getters['InfoPedido/GET_FORM_INFO_PEDIDO'].cliente?.clienteid
        || this.$store.getters['intensPedido/getFormData'].dataCapaPedido?.clienteiderp
        || this.$store.getters['intensPedido/getFormData'].enderecoEntrega?.clienteid;

      console.log('Buscando condição de pagamento para cliente ID:', clienteId);

      if (!clienteId) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Aviso',
            text: 'Selecione um cliente primeiro para buscar condições de pagamento',
            icon: 'AlertTriangleIcon',
            variant: 'warning',
          },
        });
        this.$refs.modalBuscarCondPagto.hide();
        return;
      }

      this.isLoading = true;
      try {
        const currentCondPagameto = await slsCondicaoPagamentoService.GetCondPagtoByClienteId(clienteId, {
          ...this.$store.getters['SLSCondicaoPagamento/GET_FILTERS'],
          ...this.filtersHeader,
        });

        console.log('Condições de pagamento recebidas:', currentCondPagameto);

        const condPagamentos = Array.isArray(currentCondPagameto) ? currentCondPagameto : [];

        this.$store.commit('SLSCondicaoPagamento/SET_CURRENT_COND_PAGTO', condPagamentos);

        if (condPagamentos.length === 0) {
          this.$store.commit('intensPedido/SET_CAPA_PEDIDO', {
            ...this.$store.getters['intensPedido/getFormData'].dataCapaPedido,
            condicaopagamentoid: '',
            condicaopagamentodescricao: '',
          });

          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Aviso',
              text: 'Nenhuma condição de pagamento encontrada para este cliente',
              icon: 'AlertTriangleIcon',
              variant: 'warning',
            },
          });
        }
      } catch (error) {
        console.error('Erro ao buscar condições de pagamento:', error);
        this.$store.commit('SLSCondicaoPagamento/SET_CURRENT_COND_PAGTO', []);

        this.$store.commit('intensPedido/SET_CAPA_PEDIDO', {
          ...this.$store.getters['intensPedido/getFormData'].dataCapaPedido,
          condicaopagamentoid: '',
          condicaopagamentodescricao: '',
        });

        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Erro',
            text: 'Não foi possível buscar as condições de pagamento para este cliente',
            icon: 'AlertCircleIcon',
            variant: 'danger',
          },
        });
      } finally {
        this.isLoading = false;
      }
    },
    // async getAllCondicaoPagamento() {
    //   const currentCondPagameto = await slsCondicaoPagamentoService.indexFilters({
    //     ...this.$store.getters['SLSCondicaoPagamento/GET_FILTERS'],
    //     ...this.filtersHeader
    //   })
    //   this.$store.commit('SLSCondicaoPagamento/SET_CURRENT_COND_PAGTO', currentCondPagameto)
    // },
    async info(item, index, target) {
      this.$store.commit('InfoPedido/SET_FORM_INFO_PEDIDO', {
        ...this.$store.getters['InfoPedido/GET_FORM_INFO_PEDIDO'],
        condicaoPagamento: {
          condicaopagamentoid: item.condicaopagamentoid,
          condicaopagamentodescricao: item.condicaopagamentodescricao,
        },
      });
      this.$store.commit('PicStore/SET_FILTERS_CONDICAOPAGAMENTO_ID', item.condicaopagamentoid);

      this.$root.$emit('condpagto:selected', {
        condicaopagamentoid: item.condicaopagamentoid,
        condicaopagamentodescricao: item.condicaopagamentodescricao,
      });

      // await picService.getPicPedidos()
      this.$refs.modalBuscarCondPagto.hide();
      // await this.getCondicaoPagamentoByClienteId()
      await this.resertFilterHeader();
    },
    async handlePageChange(value) {
      this.$store.commit('SLSCondicaoPagamento/SET_FILTERS', {
        ...this.$store.getters['SLSCondicaoPagamento/GET_FILTERS'],
        page: value,
      });
      await this.getCondicaoPagamentoByClienteId();
      this.currentPage = value;
    },
    async handleFiltersHeader() {
      Object.keys(this.filtersHeader).forEach((key) => {
        if (this.filtersHeader[key] === '') {
          delete this.filtersHeader[key];
        }
      });

      this.$store.commit('SLSCondicaoPagamento/SET_FILTERS', {
        ...this.$store.getters['SLSCondicaoPagamento/GET_FILTERS'],
        ...this.filtersHeader,
        page: 1,
      });
      // this.$store.getters['SLSCondicaoPagamento/GET_COND_PAGTOS'].filter(item => {
      //   return Object.keys(this.filtersHeader).every(key => {
      //     return String(item[key]).toLowerCase().includes(this.filtersHeader[key].toLowerCase())
      //   })
      // })
      await this.getCondicaoPagamentoByClienteId();
    },
    async resertFilterHeader() {
      Object.keys(this.filtersHeader).forEach((key) => {
        if (this.filtersHeader[key] === '') {
          delete this.filtersHeader[key];
        }
      });
      this.filtersHeader = {
        condicaopagamentoid: '',
        condicaopagamentodescricao: '',
      };
      await this.$store.dispatch('SLSCondicaoPagamento/resertFilters');
      this.$store.commit('SLSCondicaoPagamento/SET_CURRENT_COND_PAGTO', this.filtersHeader);
      await this.getCondicaoPagamentoByClienteId();
    },
    async checkAndFetchData() {
      const clienteId = this.$store.getters['InfoPedido/GET_FORM_INFO_PEDIDO'].cliente?.clienteid
        || this.$store.getters['intensPedido/getFormData'].dataCapaPedido?.clienteiderp;

      const isCreatePedidos = this.$router.currentRoute.name === 'pedidos-vendas-create';

      console.log('Cliente ID verificado:', clienteId);
      console.log('Dados do cliente no InfoPedido:', this.$store.getters['InfoPedido/GET_FORM_INFO_PEDIDO'].cliente);
      console.log('Dados do cliente no intensPedido:', this.$store.getters['intensPedido/getFormData'].dataCapaPedido);

      if (!clienteId) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Aviso',
            text: 'Selecione um cliente primeiro para buscar condições de pagamento',
            icon: 'AlertTriangleIcon',
            variant: 'warning',
          },
        });
        this.$refs.modalBuscarCondPagto.hide();
        return;
      }

      if (isCreatePedidos) {
        this.$store.commit('SLSCondicaoPagamento/SET_FILTERS', {
          page: 1,
        });
        this.currentPage = 1;
        await this.getCondicaoPagamentoByClienteId();
        return;
      }

      if (this.dataFetchedForCliente[clienteId] && this.currentCondPagameto.length > 0) {
        const savedFilters = this.$store.getters['SLSCondicaoPagamento/GET_FILTERS'];
        this.filtersHeader.condicaopagamentoid = savedFilters.condicaopagamentoid || '';
        this.filtersHeader.condicaopagamentodescricao = savedFilters.condicaopagamentodescricao || '';
        this.currentPage = savedFilters.page || 1;
        return;
      }

      this.$store.commit('SLSCondicaoPagamento/SET_FILTERS', {
        ...this.$store.getters['SLSCondicaoPagamento/GET_FILTERS'],
        page: 1,
      });
      this.currentPage = 1;
      await this.getCondicaoPagamentoByClienteId();

      this.dataFetchedForCliente[clienteId] = true;
    },
  },
  mounted() {
    this.$root.$on('bv::modal::show', (bvEvent, modalId) => {
      if (modalId === 'modal-buscar-condpgto-info-pedido') {
        this.checkAndFetchData();
      }
    });
  },
};
</script>

<template>
  <b-modal id="modal-buscar-condpgto-info-pedido" size="xl" ref="modalBuscarCondPagto" title="Condição Pagamento"
    ok-only ok-title="FECHAR">
    <b-overlay variant="white" :show="isLoading" spinner-variant="primary" blur="0" opacity=".75" rounded="sm">
      <b-row>
        <b-col cols="12" md="2">
          <b-form-group label="Cod Condicao Pagamento:" label-for="codCond">
            <b-input-group class="input-group-merge">
              <b-input-group-prepend is-text>
                <feather-icon icon="SearchIcon" />
              </b-input-group-prepend>
              <b-form-input id="codTabelaPreco" placeholder="Código" v-model="filtersHeader.condicaopagamentoid" />
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="6">
          <b-form-group label="Descrição:" label-for="descTabelaPreco">
            <b-input-group class="input-group-merge">
              <b-input-group-prepend is-text>
                <feather-icon icon="SearchIcon" />
              </b-input-group-prepend>
              <b-form-input id="descTabelaPreco" placeholder="Nome"
                v-model="filtersHeader.condicaopagamentodescricao" />
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="2" align-self="center">
          <b-row>
            <b-col cols="12" md="6">
              <b-button variant="success" @click="handleFiltersHeader">
                Filtrar
              </b-button>
            </b-col>
            <b-col cols="12" md="6">
              <b-button variant="danger" @click="resertFilterHeader">
                Limpar
              </b-button>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row no-gutters>
        <b-col cols="12">
          <b-table striped hover responsive :current-page="currentPage" :items="currentCondPagameto" :fields="fields"
            show-empty empty-text="Nenhuma condição de pagamento encontrada">
            <template #cell(acoes)="data">
              <b-button size="sm" variant="primary" @click="info(data.item, data.index, $event.target)">
                Selecionar
              </b-button>
            </template>

            <template #cell(clienteDocumento)="data">
              {{ data.value | formatarDocumento }}
            </template>

            <template #cell(representanteativo)="data">
              <b-badge :variant="data.value === 1 ? 'success' : 'danger'">
                {{ data.value === 1 ? 'Ativo' : 'Inativo' }}
              </b-badge>
            </template>
          </b-table>
        </b-col>

        <b-col cols="12">
          <div class="mx-2 mb-2">
            <b-row>
              <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-start">
                <span class="text-muted">{{ dataMetaRepresentante }}</span>
              </b-col>
              <!-- Pagination -->
              <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-end">
                <b-pagination v-model="currentPage" :total-rows="filters.total" :per-page="filters.perPage"
                  @change="handlePageChange($event)" first-number last-number align="center" class="my-0" />
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>
    </b-overlay>
  </b-modal>
</template>

<style scoped lang="scss"></style>
